import { useState } from 'react';

export interface SearchFilters {
  transactionNo: string;
  tenantName: string;
  operationType: string;
  startTime: string;
  endTime: string;
}

interface SearchFiltersProps {
  onSearch: (filters: SearchFilters) => void;
}

export default function SearchFilters({ onSearch }: SearchFiltersProps) {
  const [filters, setFilters] = useState<SearchFilters>({
    transactionNo: '',
    tenantName: '',
    operationType: 'all',
    startTime: '',
    endTime: ''
  });

  const handleSearch = () => {
    onSearch(filters);
  };

  const handleReset = () => {
    const resetFilters = {
      transactionNo: '',
      tenantName: '',
      operationType: 'all',
      startTime: '',
      endTime: ''
    };
    setFilters(resetFilters);
    onSearch(resetFilters);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">交易流水号</label>
          <input
            type="text"
            value={filters.transactionNo}
            onChange={(e) => setFilters({ ...filters, transactionNo: e.target.value })}
            placeholder="请输入交易流水号"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">租户名称</label>
          <input
            type="text"
            value={filters.tenantName}
            onChange={(e) => setFilters({ ...filters, tenantName: e.target.value })}
            placeholder="请输入租户名称"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">操作类型</label>
          <select
            value={filters.operationType}
            onChange={(e) => setFilters({ ...filters, operationType: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value="all">全部</option>
            <option value="recharge">充值</option>
            <option value="reversal">红冲</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">开始时间</label>
          <input
            type="datetime-local"
            value={filters.startTime}
            onChange={(e) => setFilters({ ...filters, startTime: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">结束时间</label>
          <input
            type="datetime-local"
            value={filters.endTime}
            onChange={(e) => setFilters({ ...filters, endTime: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={handleSearch}
          className="px-6 py-2 bg-teal-600 text-white text-sm rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap"
        >
          <i className="ri-search-line mr-2"></i>
          搜索
        </button>
        <button
          onClick={handleReset}
          className="px-6 py-2 bg-gray-100 text-gray-700 text-sm rounded-md hover:bg-gray-200 transition-colors whitespace-nowrap"
        >
          <i className="ri-refresh-line mr-2"></i>
          重置
        </button>
      </div>
    </div>
  );
}
